import React, {
  useContext,
  useReducer,
  createContext,
  useEffect,
  useRef,
} from "react";
import { authReducer } from "../reducers/authReducer";
import { loadMe } from "../api/auth";
import { useNavigate } from "react-router-dom";
import {
  LOGIN_WITH_OAUTH_FAIL,
  LOGIN_WITH_OAUTH_SUCCESS,
} from "../reducers/types";

const initialState = {
  token: localStorage.getItem("token"),
  isAuthenticated: false,
  isLoading: false,
  appLoaded: false,
  me: null,
  error: null,
};

export const AuthContext = createContext(initialState);

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const navigate = useNavigate();
  const shouldLoadMe = useRef(true);

  useEffect(() => {
    if (shouldLoadMe.current && state.token && !state.isAuthenticated) {
      shouldLoadMe.current = false;
      loadMe(dispatch);
    }
  }, [state.token, state.isAuthenticated]);

  useEffect(() => {
    const handleOAuthMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_API_BASE) return;
      const { token, user: me, error } = event.data;

      if (error) {
        dispatch({ type: LOGIN_WITH_OAUTH_FAIL, payload: { error } });
      } else {
        dispatch({ type: LOGIN_WITH_OAUTH_SUCCESS, payload: { token, me } });
        navigate("/dashboard");
      }
    };

    window.addEventListener("message", handleOAuthMessage);
    return () => window.removeEventListener("message", handleOAuthMessage);
  }, [navigate]);

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);
